const API_BASE_URL = 'https://shopify-column-likes-comments-api-2.vercel.app';

const LIKED_KEY_PREFIX = 'liked_';
const LIKED_ARTICLES_KEY = 'likedArticles';
const FINGERPRINT_KEY = 'user_fingerprint';

function getEnvironment() {
    const hostname = window.location.hostname;

    if(hostname.includes('develop-maison-echelle')) {
        return 'test';
    }

    return 'production';
}

function getFingerprint() {
    let fingerprint = localStorage.getItem(FINGERPRINT_KEY);

    if(!fingerprint) {
        fingerprint = 'fp_' + Math.random().toString(36).substring(2, 15) +
                      Math.random().toString(36).substring(2, 15) +
                      Date.now().toString(36);
        localStorage.setItem(FINGERPRINT_KEY, fingerprint);
    }

    return fingerprint;
}

class LikeButton {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        if(!this.container) return;

        this.articleId = this.container.dataset.articleId;
        if(!this.articleId) {
            console.error('Article ID not found');
            return;
        }
        
        this.enviroment = getEnvironment();
        this.fingerprint = getFingerprint();
        this.isLiked = this.getLocalStatus();
        this.likeCount = 0;
        this.isLoading = false;

        this.init();
    }

    async init(){
        this.render();
        await this.fetchLikeCount();
    }

    getLocalStatus() {
        return localStorage.getItem(LIKED_KEY_PREFIX + this.articleId) === 'true';
    }

    setLocalLikeStatus(status) {
        if (status) {
            localStorage.setItem(LIKED_KEY_PREFIX + this.articleId, 'true');
            this.addToLikedArticles();
        } else {
            localStorage.removeItem(LIKED_KEY_PREFIX + this.articleId);
            this.removeFromLikedArticles();
        }
    }

    addToLikedArticles() {
        const likedArticles = JSON.parse(localStorage.getItem(LIKED_ARTICLES_KEY) || '[]');
        if(!likedArticles.includes(this.articleId)) {
            likedArticles.push(this.articleId);
            localStorage.setItem(LIKED_ARTICLES_KEY, JSON.stringify(likedArticles));
        }
    }

    removeFromLikedArticles() {
        const likedArticles = JSON.parse(localStorage.getItem(LIKED_ARTICLES_KEY) || '[]');
        const filtered = likedArticles.filter(id => id !== this.articleId);
        localStorage.setItem(LIKED_ARTICLES_KEY, JSON.stringify(filtered));
    }

    async fetchLikeCount() {
        try {
            const response = await fetch(`${API_BASE_URL}/api/likes/count?articleId=${this.articleId}`);
            const data = await response.json();

            if(data.success) {
                this.likeCount = data.likesCount;
                this.updateUI();
            }
        } catch(error) {
            console.error('Failed to fetch like count:', error);
        }
    }

    async toggleLike() {
        if(this.isLoading) return;

        this.isLoading = true;

        const previousIsLiked = this.isLiked;
        const previousCount = this.likeCount;

        this.isLiked = !this.isLiked;
        this.likeCount += this.isLiked ? 1 : -1;
        this.setLocalLikeStatus(this.isLiked);
        this.updateUI();

        if (this.isLiked) {
            this.showParticles();
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/likes/toggle`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify({ 
                    articleId: this.articleId,
                    fingerprint: this.fingerprint,
                    environment: this.environment
                })
            });

            const data = await response.json();

            if(data.success) {
                this.isLiked = data.isLiked;
                this.likeCount = data.likesCount;
                this.setLocalLikeStatus(this.isLiked);
                this.updateUI();
            } else {
                this.isLiked = previousIsLiked;
                this.likeCount = previousCount;
                this.setLocalLikeStatus(this.isLiked);
                this.updateUI();
                alert(data.message || 'ネットワークエラーが発生しました');
            }
        } catch(error) {
            this.isLiked = previousIsLiked;
            this.likeCount = previousCount;
            this.setLocalLikeStatus(this.isLiked);
            this.updateUI();
            alert('ネットワークエラーが発生しました');
            console.error('Failed to toggle like:', error);
        } finally {
            this.isLoading = false;
        }
     }

     showParticles() {
        console.log('Particle animation!');
     }

     updateUI() {
        const button = this.container.querySelector('.like-button');
        const heart = this.container.querySelector('.like-heart');
        const count = this.container.querySelector('.like-count');

        if (button) {
            button.classList.toggle('liked', this.isLiked);
        }
        if (heart) {
            heart.textContent = this.isLiked ? '♥' : '♡';
        }
        if(count) {
            count.textContent = this.likeCount;
        }
     }

     render() {
        const html = `
        <div class="like-section">
            <p class="like-description">いいね♡やコメントをお待ちしております🪜</p>
            <button class="like-button ${this.isLiked ? 'liked' : ''}" type="button">
                <span class="like-heart">${this.isLiked ? '♥' : '♡'}</span>
                <span class="like-count">${this.likeCount}</span>
            </button>
        </div>
        `;

        this.container.innerHTML = html;

        const button = this.container.querySelector('.like-button');
        button.addEventListener('click', () => this.toggleLike());
     }
}

document.addEventListener('DOMContentLoaded', () => {
    new LikeButton('like-button');
});